import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import {
  advanceLableInitialValue,
  LabelTabs,
} from 'components/organisms/forms/advance/advanceLabelForm';
import { useHasPermission } from 'hooks';
import { useParamId } from 'hooks/useParamId';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePostAdvance } from 'services/advance';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

export const contractTemplateFormInitialStatus = {
  description: '',
  amount: '',
  maximumRepaymentPercentage: '',
  forSignature: false,
  repaymentsFromAllContracts: false,
  contracts: [],
  new: '',
};

const CreateAdvance = () => {
  const { t } = useTranslation();
  const hasPermission = useHasPermission();

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const goBackToLabel = () => navigate(`/label/`);

  const labelId = useParamId('/advance');

  const addAdvance = usePostAdvance();

  const onCreateAdvance = async (values: any) => {
    const { contracts, statusId, ...rest } = values;

    const getConstracts = contracts?.map((contract: any) => contract.id);

    const advanceCreate = {
      ...values,
      labelId: labelId,
      contracts: getConstracts === undefined ? [] : getConstracts,
      forSignature: statusId,
      settlementPeriodId: values.settlementPeriodId,
    };

    await addAdvance.mutateAsync(advanceCreate, {
      onSuccess: async id => {
        navigate(`/label/${labelId}/advance/${id}/repayments`);
      },
    });
  };

  return (
    <Form.AdvanceLabelForm
      status={{ displayMode: false }}
      customBackItem={
        <Button type='button' onlyIcon onClick={goBackToLabel}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <>
          {hasPermission('AdvancePermissionsLIST**', 1) && (
            <Button type='submit' variant={BUTTON_VARIANT.submit}>
              <Button.Text text={t(`button.create`)} />
            </Button>
          )}
        </>
      }
      initialStatus={contractTemplateFormInitialStatus}
      initialValues={advanceLableInitialValue}
      onSubmit={onCreateAdvance}
      disableTabs={[LabelTabs.repayments]}
    />
  );
};

export default CreateAdvance;
